var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDownSwipeWeb = function SvgDownSwipeWeb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 19.1641L18.207 12.9571L16.793 11.5431L12 16.3361L7.20697 11.5431L5.79297 12.9571L12 19.1641ZM12 13.5141L18.207 7.30707L16.793 5.89307L12 10.6861L7.20697 5.89307L5.79297 7.30707L12 13.5141Z"
  })));
};
export default SvgDownSwipeWeb;